import type { UserState } from 'cpool-constants';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { createSelectors } from './utils/createSelectors';

const useUserBaseStore = create<UserState>()(
    persist(
        (_set) => ({
            jwt: null,
            rt: null,
            rtDecoded: null,
            user: null,
        }),
        {
            name: 'user-storage',
        },
    ),
);

export const useUserStore = createSelectors(useUserBaseStore);

export const setUser = (user: UserState['user']) => {
    useUserBaseStore.setState((state) => {
        return { ...state, user };
    });
};

export const logout = () => {
    useUserBaseStore.setState((state) => {
        return { ...state, rtDecoded: null, user: null };
    });
};

export const login = (user: UserState['user'] | null, rtDecoded: UserState['rtDecoded']) => {
    useUserBaseStore.setState((state) => {
        return { ...state, rtDecoded, user };
    });
};
